import React from 'react'
import logo from 'assets/images/logo-white.png'
import background from 'assets/getdown/chelsea-reed-photo.jpg'

const blobClipPath =
  'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)'

type Props = {
  quote: string
  testimonialTitle?: string
  person: string
  title: string
}

/** Same look as the testimonial on the STL Get Down site */
export const Testimonial = ({
  quote,
  testimonialTitle = 'STL Swing',
  person,
  title,
}: Props) => (
  <div className='py-10 md:py-14'>
    <div className='max-w-5xl mx-auto sm:px-6 lg:px-8'>
      <div className='relative px-6 py-20 overflow-hidden bg-gray-900 shadow-xl sm:rounded-3xl sm:px-10 sm:py-24 md:px-12 lg:px-20'>
        <img
          className='absolute inset-0 object-cover w-full h-full brightness-150 saturate-0'
          src={background}
          alt=''
        />
        <div className='absolute inset-0 bg-gray-900/90 mix-blend-multiply' />
        <div
          className='absolute -left-80 -top-56 transform-gpu blur-3xl'
          aria-hidden='true'>
          <div
            className='aspect-[1097/845] w-[68.5625rem] bg-gradient-to-r from-[#ff4694] to-[#776fff] opacity-[0.45]'
            style={{ clipPath: blobClipPath }}
          />
        </div>
        <div
          className='hidden md:absolute md:bottom-16 md:left-[50rem] md:block md:transform-gpu md:blur-3xl'
          aria-hidden='true'>
          <div
            className='aspect-[1097/845] w-[68.5625rem] bg-gradient-to-r from-[#ff4694] to-[#776fff] opacity-25'
            style={{ clipPath: blobClipPath }}
          />
        </div>
        <div className='relative max-w-2xl mx-auto lg:mx-0'>
          <div className='flex items-center justify-start'>
            <img className='w-auto h-12' src={logo} alt='' />
            <h3 className='pl-2 text-3xl font-extrabold text-white'>
              {testimonialTitle}
            </h3>
          </div>
          <figure>
            <blockquote className='mt-6 text-lg font-semibold text-white sm:text-xl sm:leading-8'>
              <p>{quote}</p>
            </blockquote>
            <figcaption className='mt-6 text-base text-white'>
              <div className='font-semibold'>{person}</div>
              <div className='mt-1'>{title}</div>
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
)

export const NewZealandTestimonial = () => (
  <Testimonial
    quote='"Coming to STL Swing allows me to enjoy the white sandy beaches and crystal clear waters of Missouri instead of the barren hellscape I normally call home."'
    person='Jacinda Ardern'
    title='President of New Zealand'
  />
)

export const JeffBezosTestimonial = () => (
  <Testimonial
    quote='"I wish STL Swing existed on July 5, 1994 so I could have bought a pass instead of creating a worthless book company."'
    person='Jeff Bezos'
    title='CEO of Amazon'
  />
)

export const NeilArmstrongTestimonial = () => (
  <Testimonial
    quote='"I wish STL Swing existed on July 20, 1969 so I could have bought a pass instead of wasting my time faking a moon landing."'
    person='Neil Armstrong'
    title='First Man on the Moon, allegedly'
  />
)
